import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JobPriceDefiningAnswers, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobPriceDefiningAnswersAdapter = createEntityAdapter<JSONApiDataObject<JobPriceDefiningAnswers>>();

const jobPriceDefiningAnswersSlice = createSlice({
  name: 'jobPriceDefiningAnswers',
  initialState: jobPriceDefiningAnswersAdapter.getInitialState({
    loading: undefined,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<JobPriceDefiningAnswers>>),
  reducers: {
    jobPriceDefiningAnswersAdded: jobPriceDefiningAnswersAdapter.setMany,
    jobPriceDefiningAnswersUpsert: jobPriceDefiningAnswersAdapter.upsertMany
  }
});

export const jobPriceDefiningAnswersSelector =
  jobPriceDefiningAnswersAdapter.getSelectors((state: RootState) => state.jobPriceDefiningAnswers);

export default jobPriceDefiningAnswersSlice;
